import { Box } from "@mui/material";
import { ControlsPanel } from "@/features/controls-panel/public";
import { FactoryMap } from "@/features/factory-map/public";
import { StatsPanel } from "@/features/stats/public";

/**
 * 工場ツインのメインページ。
 * 既存の FactoryMap / StatsPanel / ControlsPanel をルートで集約する。
 */
export function SimulationPage() {
  return (
    <>
      <Box sx={{ position: "relative", flex: 1, minHeight: 0 }}>
        <FactoryMap />
        <StatsPanel />
      </Box>
      <ControlsPanel />
    </>
  );
}
